/* Data source selection - three modes:
 *   "socrata"  browser queries data.texas.gov directly (SODA2, CORS) - LIVE
 *   "sample"   in-browser generated dataset, no network - demo/offline
 *   "api"      default: the Phase 4 client adapter talking to
 *              meridian-server.js (or the dev fixture) via /api/meridian
 * Set at build time with VITE_DATA_MODE, or at runtime with
 * window.MERIDIAN_API = "sample" | "socrata". */
import { liveDataService } from "../../meridian-data-service.js";
import { sampleDataService } from "./sample-data.js";
import { socrataDataService } from "./live-socrata.js";

const runtime = typeof window !== "undefined" ? window.MERIDIAN_API : undefined;
const mode = import.meta.env?.VITE_DATA_MODE || (runtime === "sample" || runtime === "socrata" ? runtime : "api");

export const DATA_MODE = mode === "socrata" ? "live" : mode === "sample" ? "sample" : "api";
export const IS_SAMPLE = DATA_MODE === "sample";

export const dataService =
  mode === "socrata" ? socrataDataService :
  mode === "sample" ? sampleDataService :
  liveDataService;

const KEY = "meridian.watchlist.v1";

export function loadWatchlist() {
  try { return new Set(JSON.parse(localStorage.getItem(KEY) || "[]")); }
  catch { return new Set(); }
}

export function saveWatchlist(set) {
  try { localStorage.setItem(KEY, JSON.stringify([...set])); } catch {}
}
